<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/dewas-list">Daftar Dewan Pengawas</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Arsip Dewan Pengawas
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Arsip Dewan Pengawas</h5>
    </div>
    <LogPopupTemplate ref="logPopup" />
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="arsipListStore.dataSourceArsipList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :filter-value="filterValue"
          :filter-sync-enabled="true"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing($event)"
        >
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
          />
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxColumnFixing :enabled="true" />
          <!-- <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          /> -->
          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />
          <dx-column
            data-field="id"
            caption="ARSIP ID"
            :visible="false"
            :allow-exporting="false"
          >
          </dx-column>
          <template #tagBoxEditor="{ data: cellInfo }">
            <EmployeeTagBoxComponent
              :cell-info="cellInfo"
              :data-source="dewasSource"
              :data-grid-component="cellInfo.component"
            />
          </template>
          <dx-column
            data-field="id"
            caption="id"
            data-type="number"
            :visible="false"
          />
          <dx-column
            data-field="user_id"
            caption="user_id"
            data-type="number"
            :visible="false"
          />

          <DxColumn
            data-field="arsip_kategoris_nama"
            caption="Kategori Arsip"
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.getArsipKategoriSource().value,
            }"
          >
          </DxColumn>
          <DxColumn
            data-field="tgl"
            caption="Tgl Arsip"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
          >
            <DxRequiredRuleDataGrid />
          </DxColumn>

          <DxColumn
            data-field="nomor_arsip"
            caption="No. Arsip"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <DxColumn
            data-field="arsips_nama"
            caption="Nama Arsip"
            :allowHeaderFiltering="false"
            :min-width="200"
          >
            <DxRequiredRuleDataGrid />
          </DxColumn>
          <DxColumn
            data-field="ket"
            caption="Ket"
            :allowHeaderFiltering="false"
          >
          </DxColumn>
          <dx-column
            data-field="arsip_dewas_dewas_ids"
            caption="Dewan Pengawas Bersangkutan"
            :visible="true"
            edit-cell-template="tagBoxEditor"
            :cell-template="tagboxCellTemplate"
            :allow-filtering="true"
            :allow-sorting="false"
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.getDewasSource(dewasSource, 'crud').value,
            }"
          >
          </dx-column>

          <DxColumn
            :allowHeaderFiltering="false"
            :allow-filtering="false"
            :allow-sorting="true"
            :allow-exporting="false"
            :allow-editing="true"
            :allow-adding="true"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
            edit-cell-template="editFileTemplate"
          >
            <DxRequiredRuleDataGrid />
          </DxColumn>
          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />
          <template #editFileTemplate="{ data }">
            <div>
              <DxFileUploader
                ref="fileUploaderRef"
                accept="*"
                upload-mode="useForm"
                @value-changed="onFileValueChanged($event, { data })"
              />
            </div>
          </template>

          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="commonFunction.handleClickDocument(data, 'File Arsip')"
                icon="download"
              />
            </div>
          </template>
          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="id"
            data-type="number"
            caption="Opsi"
            :allow-exporting="false"
            :allow-edititng="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="getOptions(data)"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClickDropdown"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import EmployeeTagBoxComponent from "./EmployeeTagBoxComponent.vue";
import { BASE_URL } from "@/global-constants";
import { useArsipListStore } from "@/stores/views/arsip-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import * as commonFunction from "@/utils/common-function.js";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
  DxRequiredRule as DxRequiredRuleDataGrid,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import { useDewasListStore } from "@/stores/views/dewas-list-store";

/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    EmployeeTagBoxComponent,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    DxRequiredRuleDataGrid,
    DxFileUploader,
  },
  setup() {
    const arsipListStore = useArsipListStore();
    const dewasListStore = useDewasListStore();
    const commonStore = useCommonStore();
    arsipListStore.dataSourceArsipList.filter(["arsip_dewas"]);
    // arsipListStore.dataSourceArsipList.filterDefault(["arsip_dewas"]);
    return {
      arsipListStore,
      dewasListStore,
      commonStore,
      commonFunction,
    };
  },
  data() {
    const vm = this;
    return {
      logPopupRef: null,
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      filterValue: [],

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
      dewasSource: [{ id: null, display_expr: null, nama: null }],
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },
  async mounted() {
    let tempA = await this.dewasListStore.dataSourceDewasListCoba(null, [
      {
        selector: "dewas.nama",
        desc: false,
      },
    ]);
    tempA.data.unshift({ id: null, display_expr: null });

    this.dewasSource = tempA.data; //all pegawai
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    getOptions(data) {
      return [
        {
          text: "Log Perubahan Data",
          dewas_id: null,
          row_key: data.key,
        },
        // other options...
      ];
    },

    onContextMenuPreparing(e) {
      if (e.target == "content") {
        e.itemData = {
          pegawai_id: e.row.data.pegawai_id,
          row_key: e.row.data.id,
        };

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];

        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData.text = "Log Perubahan Data";
            this.$refs.logPopup.showBySubject(e.row.key, "Arsip");
          },
        });
      }
    },

    onItemClickDropdown(e) {
      const rowKey = e.itemData.row_key;
      if (e.itemData.text === "Log Perubahan Data") {
        this.$refs.logPopup.showBySubject(rowKey, "Arsip");
      }
    },
    tagboxCellTemplate(cellElement, cellInfo) {
      cellElement.innerHTML = ""; // Clear the cell content
      const wrapper = document.createElement("div"); // Create a wrapper div

      cellInfo.data.arsip_dewas_dewas_ids.forEach((id) => {
        const dewas = this.dewasSource.find((dewas) => dewas.id === id);

        if (dewas) {
          const badge = document.createElement("span"); // Create a span for the badge
          badge.className = "badge badge-primary mr-1"; // Add Bootstrap classes
          badge.style.backgroundColor = "#e0e0e0"; // Bootstrap primary color
          badge.style.color = "#333333";
          badge.style.padding = "0.4em 0.8em";
          badge.style.borderRadius = "0.25rem";
          badge.style.marginRight = "0.25rem";
          badge.style.display = "inline-block";
          badge.style.fontSize = "0.875rem";
          badge.textContent = dewas.nama; // Set the employee name as the badge content

          // Add click event listener to call onItemClick
          badge.addEventListener("click", () => {
            this.onItemClick(dewas.id);
          });

          // Optionally, add cursor pointer to indicate it's clickable
          badge.style.cursor = "pointer";

          badge.addEventListener("mouseover", () => {
            badge.style.backgroundColor = "#333333"; // Darker background on hover
            badge.style.color = "#ffffff"; // White text on hover
          });

          badge.addEventListener("mouseout", () => {
            badge.style.backgroundColor = "#e0e0e0"; // Original background color
            badge.style.color = "#333333"; // Original text color
          });

          wrapper.appendChild(badge); // Append the badge to the wrapper
        }
      });

      cellElement.appendChild(wrapper); // Append the wrapper to the cell element
    },

    onFileValueChanged(e, cellInfo) {
      const uploadButton = e.element.querySelector(
        ".dx-fileuploader-upload-button",
      );
      const fileContainer = e.element.querySelector(
        ".dx-fileuploader-files-container",
      );
      if (uploadButton) {
        uploadButton.style.display = "none"; // Hide the upload button
      }
      if (fileContainer) {
        fileContainer.style.display = "block"; // Hide the file container
      }

      if (e.value && e.value[0]) {
        const fileNameTemp = e.value[0].name;
        const fileExtension = fileNameTemp.substring(
          fileNameTemp.lastIndexOf(".") + 1,
        );
        this.file = e.value[0];
        var guid = this.uuidv4();
        this.fileName = guid + "." + fileExtension;
        this.filePath = "files/" + this.fileName;
        cellInfo.data.setValue(this.filePath);
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    },
    displayPenyesuaian(e) {
      if (e.data.status_penyesuaian) return "Penyesuaian";
      return "";
    },
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onItemClick(dewasId) {
      const url = this.$router.resolve({
        name: "dewas-detail",
        query: { id: dewasId },
      }).href;
      window.open(url, "_blank");
    },
    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    refreshDatagrid(gridRef) {
      // this.arsipListStore.dataSourceArsipList.filter(null);
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pemegang Kendaraan Dinas.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
